import { Close, Search } from '@mui/icons-material'
import { Box, Grid, Modal, TextField } from '@mui/material'
import React, { ReactNode, useEffect, useState } from 'react'
import { getRGBA } from 'utils/color'
import { getIcon } from 'utils/get-icon'
import { IOptionToChange } from '../card'
import { useStyles } from './styles'

interface ModalChangeOutputProps {
  open: boolean
  onClose: () => void
  onSelect: (connectorName: string) => void
  options: IOptionToChange[]
}

interface ConectorOption {
  name: string
  icon: ReactNode
}

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 594,
  Height: 'auto',
  bgcolor: 'background.paper',
  boxShadow: 24,
  borderRadius: '0.35rem',
  border: 'none',
  outline: 'none',
  padding: '0.25rem',
  overflow: 'hidden',
}

const ModalChangeOutput: React.FC<ModalChangeOutputProps> = ({ open, onClose, onSelect, options: opt }) => {
  const [options, setOptions] = useState<IOptionToChange[]>(opt)
  const classes = useStyles()

  const handleSelectOption = (option: string) => {
    onSelect(option)
    onClose()
  }

  const onFilterOptions = (value: string) => {
    const filteredOptions = opt.filter(({ name }) => name.toLowerCase().includes(value.toLowerCase()))

    setOptions(!value ? opt : filteredOptions)
  }

  useEffect(() => {
    setOptions(opt)
  }, [opt])

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby='modal-modal-title'
      aria-describedby='modal-modal-description'
    >
      <Box sx={style}>
        <Box className={classes.container}>
          <Box className={classes.header}>
            <h6>Selecione o conector</h6>
            <Close
              className={classes.closeBtn}
              onClick={onClose}
            />
          </Box>

          <Box className={classes.searchInput}>
            <TextField
              label='Nome do conector'
              placeholder='Procure pelo conector'
              sx={{
                p: 0,
                m: 0,

                '& .MuiInputLabel-root': {
                  backgroundColor: 'white !important',
                  font: 'Nunito Sans',
                  color: getRGBA('#0F0F1E', 0.6),
                  fontSize: '0.75rem',
                  fontWeight: 400,
                  lineHeight: '0.75rem',
                },
              }}
              fullWidth
              onChange={(e) => onFilterOptions(e.target.value)}
              InputProps={{
                startAdornment: (
                  <Search
                    sx={{
                      color: getRGBA('#0F0F1E', 0.6),
                      marginRight: '0.5rem',
                    }}
                  />
                ),
              }}
            />
          </Box>

          <Box className={classes.options}>
            {options.map(({ id, name }) => (
              <Grid
                container
                key={Math.random()}
                className={classes.item}
                onClick={() => handleSelectOption(id)}
              >
                <Grid
                  item
                  xs={1}
                  className={classes.itemGrid}
                >
                  {getIcon(name)}
                </Grid>
                <Grid
                  item
                  xs={11}
                  className={classes.itemGrid}
                >
                  <span>{name}</span>
                </Grid>
              </Grid>
            ))}
          </Box>
        </Box>
      </Box>
    </Modal>
  )
}

export default ModalChangeOutput
